const actions = {
	TAX_INFO_UPDATE: 'TAX_INFO_UPDATE',
	updateTaxInfo: (values) => ({
		type: actions.TAX_INFO_UPDATE,
		values,
	}),
};

export default actions;
